module.exports = __webpack_public_path__ + "static/loading-background-ceb7482ce7a01896fa963974205e51d6.png";